import React, { useState, useEffect } from 'react'

import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import { makeStyles, confirmActivation } from '@material-ui/core/styles'

import moment from 'moment'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	summaryHeader: {
		fontSize: '12px',
		color: '#1A1A35',
		fontWeight: '800',
		opacity: '.75'
	},
	text: {
		color: '#1A1A35',
		fontSize: '14px'
	}
}))

const EditAutoRenewDialog = (props) => {
	const classes = useStyles()
	let { isShown, setIsShown, updateMembership } = props
	const [membership, setMembership] = useState(null)
	const [autoRenew, setAutoRenew] = useState(false)

	useEffect(() => {
		if (props.membership && props.membership._id) {
			setAutoRenew(props.membership.auto_renew)
			setMembership({
				...props.membership,
				auto_renew: !props.membership.auto_renew
			})
		}
	}, [props.membership])

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setIsShown(false)}
			PaperProps={{
				style: {
					minWidth: '500px',
					maxWidth: '500px',
					width: '500px',
					height: '225px'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				{autoRenew ? 'Disable ' : 'Enable '} Auto Renew
			</DialogTitle>
			<DialogContent>
				<Typography>
					{autoRenew
						? `Turning off auto renew means that this membership will expire ${moment(
								membership.end_date
						  ).format('MMM D, YYYY')} `
						: 'Turning on auto renew means that this membership automatically renews until this action is disabled.'}
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						updateMembership(membership)
						setIsShown(false)
					}}
					color="secondary">
					{autoRenew ? 'Disable ' : 'Enable '} Auto Renew
				</Button>
				<Button variant="outlined" onClick={() => setIsShown(false)} color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default EditAutoRenewDialog
